import { useHistory } from 'react-router'
import React from 'react'

import { EditedJobPost } from 'components/EditPost'

import Position from 'components/EditPost/Position'
import { usePersistedState } from 'hooks'
import { entities } from 'reduxStore'

export default function EditJobPostPositionPage() {
	const history = useHistory()
	const { mode }: { mode: 'post' | 'edit' } = history.location.state as any

	const [persistedJob, saveJob] = usePersistedState({
		entityName: entities.editedJobPost,
		initialValue: {} as EditedJobPost,
	})

	return (
		<Position
			mode={mode}
			isNextAvailable={false}

			initBasis={persistedJob.basis}
			initPosition={persistedJob.position}

			onNext={(
				{
					basis,
					position,
				},
			) => {
				saveJob({
					...persistedJob,
					basis,
					position,
				})

				return 'postOfficeLocation'
			}}
		/>
	)
}
